import { mapValues } from './objects'

/**
 * Checks if the passed parameter is a Date
 * @param val
 */
const isDate = (val: any) =>
  val && Object.prototype.toString.call(val) === '[object Date]' && !isNaN(val)

/**
 * This function clones in a deep way any kind of data including arrays and objects
 * Check the documentation below for further details
 * https://stackoverflow.com/questions/34480936/how-to-clone-a-javascript-object-including-getters-and-setters
 * @param item unknown
 */
export const cloneDeep = <T>(item: T): T => {
  // null is considered an object in JS, so we must exclude from the ist of checks below,
  // because it would pass and break the function
  if (item === null) return item

  if (typeof item !== 'object') {
    return item
  } else if (isDate(item)) {
    return new Date(item as unknown as Date) as any
  } else if (Array.isArray(item)) {
    return item.map(cloneDeep) as unknown as T
  } else {
    return Object.setPrototypeOf(
      mapValues((v) => cloneDeep(v), item),
      Object.getPrototypeOf(item)
    )
  }
}

/**
 * Returns true whenever the passed parameter is defined
 * @param itm
 */
export const isDefined = <T>(itm: T | undefined): itm is T => !!itm
